import Vue from 'vue'
import Router from 'vue-router'
import index from '../components/area/index'
import JXData from '../components/area/JXData'
import localArea from '../components/area/localArea'
import industryAnalysis from '../components/area/industryAnalysis'
import goodsType from '../components/area/goodsType'
import transactionMode from '../components/area/transactionMode'
import tradingPlatform from '../components/area/tradingPlatform'
import rankingList from '../components/area/rankingList'
import countrysideBusiness from '../components/agricultureModel/countrysideBusiness'
import agricultureProducts from '../components/agricultureModel/agricultureProducts'

import agriculturalMeans from '../components/agricultureModel/agriculturalMeans'
import ganPin from '../components/ganPinMonitoring/ganpin-index'
import ganPinAnalysis from '../components/ganPinMonitoring/ganPin-analysis'
import industry from '../components/ganPinMonitoring/industry'
import industryDetail from '../components/ganPinMonitoring/industryDetail'
import live from '../components/characteristic/live'
import selfBuildPlatform from '../components/characteristic/selfBuildPlatform'
import vertical from '../components/characteristic/vertical'
import community from '../components/characteristic/community'
import companyIndex from '../components/company/company-index'
import companyDetail from '../components/company/company-detail'
import restaurant from '../components/onlineService/restaurant'
import tour from '../components/onlineService/tour'
import login from '../components/login'
import nonPhysical from '../components/area/nonPhysical'
import companyFocus from '../components/company/companyFocus'
import focusDetail from '../components/company/focusDetail'
import VaildCode from "../components/SIdentify";
import CityIndex from "../components/area/CityIndex";

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/index',
      name: 'index',
      meta: {
          requireAuth: true,
        },
      component: index
    },{
      path: '/CityIndex',
      name: 'CityIndex',
      meta: {
        requireAuth: true,
      },
      component: CityIndex
    },
    {
      path: '/restaurant',
      name: 'restaurant',
      meta: {
        requireAuth: true,
      },
      component: restaurant
    }, {
      path: '/tour',
      name: 'tour',
      meta: {
        requireAuth: true,
      },
      component: tour
    }, {
      path: '/JXData',
      name: 'JXData',
      meta: {
        requireAuth: true,
      },
      component: JXData
    }, {
      path: '/localArea',
      name: 'localArea',
      meta: {
        requireAuth: true,
      },
      component: localArea
    }, {
      path: '/goodsType',
      name: 'goodsType',
      meta: {
        requireAuth: true,
      },
      component: goodsType
    }, {
      path: '/industryAnalysis',
      name: 'industryAnalysis',
      meta: {
        requireAuth: true,
      },
      component: industryAnalysis
    }, {
      path: '/nonPhysical',
      name: 'nonPhysical',
      meta: {
        requireAuth: true,
      },
      component: nonPhysical
    }, {
      path: '/transactionMode',
      name: 'transactionMode',
      meta: {
        requireAuth: true,
      },
      component: transactionMode
    }, {
      path: '/tradingPlatform',
      name: 'tradingPlatform',
      meta: {
        requireAuth: true,
      },
      component: tradingPlatform
    }, {
      path: '/rankingList',
      name: 'rankingList',
      meta: {
        requireAuth: true,
      },
      component: rankingList
    }, {
      path: '/countrysideBusiness',
      name: 'countrysideBusiness',
      meta: {
        requireAuth: true,
      },
      component: countrysideBusiness
    }, {
      path: '/agricultureProducts',
      name: 'agricultureProducts',
      meta: {
        requireAuth: true,
      },
      component: agricultureProducts
    }, {
      path: '/agriculturalMeans',
      name: 'agriculturalMeans',
      meta: {
        requireAuth: true,
      },
      component: agriculturalMeans
    }, {
      path: '/ganPin',
      name: 'ganPin',
      meta: {
        requireAuth: true,
      },
      component: ganPin
    }, {
      path: '/ganPinAnalysis',
      name: 'ganPinAnalysis',
      meta: {
        requireAuth: true,
      },
      component: ganPinAnalysis
    },{
      path: '/industry',
      name: 'industry',
      meta: {
        requireAuth: true,
      },
      component: industry
    },{
      path: '/industryDetail',
      name: 'industryDetail',
      meta: {
        requireAuth: true,
      },
      component: industryDetail
    },{
      path:'/community',
      name: 'community',
      meta: {
        requireAuth: true,
      },
      component: community
    }, {
      path:'/live',
      name: 'live',
      meta: {
        requireAuth: true,
      },
      component: live
    },{
      path:'/vertical',
      name: 'vertical',
      meta: {
        requireAuth: true,
      },
      component: vertical
    },{
      path:'/selfBuildPlatform',
      name: 'selfBuildPlatform',
      meta: {
        requireAuth: true,
      },
      component: selfBuildPlatform
    },{
      path: '/companyIndex',
      name: 'companyIndex',
      meta: {
        requireAuth: true,
      },
      component: companyIndex
    }, {
      path: '/companyDetail',
      name: 'companyDetail',
      meta: {
        requireAuth: true,
      },
      component: companyDetail
    }, {
      path: '/companyFocus',
      name: 'companyFocus',
      meta: {
        requireAuth: true,
      },
      component: companyFocus
    }, {
      path: '/focusDetail',
      name: 'focusDetail',
      meta: {
        requireAuth: true,
      },
      component: focusDetail
    },
    // {
    //   path: '/agricultureProducts',
    //   name: 'agricultureProducts',
    //   meta: {
    //     requireAuth: true,
    //   },
    //   component: agricultureProducts
    // },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: login
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js